import { Checkbox as CheckboxInput, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { OrderReviewContext } from '../../../../QaOrderReview/OrderReviewContext';
import { getAnswerImages, removeChildAnswers } from '../../FormDefinitionInput.utils';
import styles from './Checkbox.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  checkIfAnswerTriggersNewFormHeader: PropTypes.func.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  imageToEdit: PropTypes.object,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const Checkbox = ({
  classes,
  checkIfAnswerTriggersNewFormHeader,
  formDefinition,
  isReadOnly,
  imageToEdit,
  removeAnswers,
  saveAnswers,
  updateFormHeaders,
}) => {
  const { dispatch: orderReviewDispatch } = useContext(OrderReviewContext);
  const saveAnswersDebounceHandler = useCallback(
    debounce(newAnswers => {
      saveAnswers(newAnswers);
    }, 750),
    [],
  );

  const handleOnChange = async event => {
    const answerImages = getAnswerImages(formDefinition, imageToEdit);
    const checkBoxAnswerValueId = parseInt(event.target.value);
    let newAnswers = formDefinition.answers.map(answer => ({
      orderFormHeaderId: formDefinition.orderFormHeaderId,
      formDefinitionId: formDefinition.formDefinitionId,
      questionId: formDefinition.questionId,
      formQaAnswerId: answer.formQaAnswerId,
      type: formDefinition.answerType,
      valueId: answer.valueId,
      value: null,
      text: null,
      modifiedOn: new Date(),
      images: answerImages,
      default: answer.default,
    }));

    const checkboxAnswerExists = newAnswers.some(answer => answer.valueId === checkBoxAnswerValueId);
    if (checkboxAnswerExists) {
      newAnswers = newAnswers.filter(answer => answer.valueId !== checkBoxAnswerValueId);
      removeChildAnswers(formDefinition, checkBoxAnswerValueId, true, orderReviewDispatch, removeAnswers);
    } else {
      newAnswers = [
        {
          orderFormHeaderId: formDefinition.orderFormHeaderId,
          formDefinitionId: formDefinition.formDefinitionId,
          questionId: formDefinition.questionId,
          formQaAnswerId: null,
          type: formDefinition.answerType,
          valueId: checkBoxAnswerValueId,
          value: null,
          text: null,
          modifiedOn: new Date(),
          images: answerImages,
          default: false,
        },
      ];
      checkIfAnswerTriggersNewFormHeader(checkBoxAnswerValueId);
    }

    if (newAnswers.length === 0) {
      newAnswers.push({
        orderFormHeaderId: formDefinition.orderFormHeaderId,
        formDefinitionId: formDefinition.formDefinitionId,
        questionId: formDefinition.questionId,
        formQaAnswerId: null,
        type: formDefinition.answerType,
        valueId: formDefinition.answerTriggers.find(at => at.answerValue === 'No').answerValueId,
        value: null,
        text: null,
        modifiedOn: new Date(),
        images: answerImages,
        default: formDefinition.answerTriggers.find(at => at.answerValue === 'No').default,
      });
      checkIfAnswerTriggersNewFormHeader(
        formDefinition.answerTriggers.find(at => at.answerValue === 'No').answerValueId,
      );
    }

    updateFormHeaders(newAnswers);
    saveAnswersDebounceHandler(newAnswers);
  };

  return (
    <FormControl className={classes.formControl} disabled={isReadOnly}>
      <FormGroup>
        {formDefinition.answerTriggers.map(
          at =>
            at.answerValue === 'Yes' && (
              <React.Fragment key={at.answerValueId}>
                <FormControlLabel
                  control={
                    <CheckboxInput
                      checked={formDefinition.answers.some(a => a.valueId === at.answerValueId)}
                      onChange={handleOnChange}
                      value={at.answerValueId.toString()}
                    />
                  }
                  label={formDefinition.questionValue}
                />
              </React.Fragment>
            ),
        )}
      </FormGroup>
    </FormControl>
  );
};

Checkbox.propTypes = propTypes;
export default withStyles(styles)(Checkbox);
